export const strapiImage = (src: string): string =>
    src.startsWith('http') ? src : `${process.env.NEXT_INTERNAL_CONTENT_ENDPOINT}${src}`

export const strapiPublicImage = (src: string): string =>
    src.startsWith('http') ? src : `${process.env.NEXT_PUBLIC_STORAGE_CONTAINER}${src}`